import type {Mapper} from 'framework';
import type {CatalogMuscle} from '../../domain/catalog-muscle';
import type {CatalogMuscleDto} from '../dto/workout.dto';

export class CatalogMuscleDtoToCatalogMuscleMapper
  implements Mapper<CatalogMuscleDto, CatalogMuscle>
{
  transform(dto: CatalogMuscleDto): CatalogMuscle {
    return {
      id: dto.id,
      slug: dto.slug,
      name: dto.name,
    };
  }
}
